var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertChained(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#024BD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2711 21.9075C34.3787 21.9075 32.7988 23.2281 32.3772 24.9932H27.8041V20.5176C27.8041 17.6566 25.4768 15.3295 22.6161 15.3295H20.8493C20.4294 14.0635 19.2525 13.1445 17.8478 13.1445C16.0925 13.1445 14.6729 14.5659 14.6729 16.3195C14.6729 18.0731 16.0925 19.4945 17.8478 19.4945C19.2525 19.4945 20.4294 18.5755 20.8493 17.3112H22.6161C24.3844 17.3112 25.8223 18.7491 25.8223 20.5176V24.9932H20.8674C20.4689 23.6958 19.2758 22.7471 17.8478 22.7471C16.0925 22.7471 14.6729 24.1685 14.6729 25.9205C14.6729 27.6741 16.0925 29.0954 17.8478 29.0954C19.3319 29.0954 20.5699 28.0707 20.9168 26.694H25.8223V31.1697C25.8223 32.9365 24.3844 34.376 22.6161 34.376H20.8493C20.4294 33.11 19.2525 32.1927 17.8478 32.1927C16.0925 32.1927 14.6729 33.6125 14.6729 35.3661C14.6729 37.1197 16.0925 38.541 17.8478 38.541C19.2525 38.541 20.4294 37.6221 20.8493 36.3577H22.6161C25.4768 36.3577 27.8041 34.029 27.8041 31.1697V26.694H32.3359C32.6979 28.5384 34.3227 29.9351 36.2711 29.9351C38.4858 29.9351 40.2859 28.1352 40.2859 25.9205C40.2859 23.7074 38.4858 21.9075 36.2711 21.9075V21.9075ZM36.2709 28.4119C34.8977 28.4119 33.7804 27.2946 33.7804 25.9211C33.7804 24.5493 34.8977 23.4321 36.2709 23.4321C37.6461 23.4321 38.7633 24.5493 38.7633 25.9211C38.7633 27.2946 37.6461 28.4119 36.2709 28.4119Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertChained);
export default __webpack_public_path__ + "static/media/alert-chained.141596b2.svg";
export { ForwardRef as ReactComponent };